import React from 'react';
import ChatBox from './ChatBox';

class LobbyChat extends React.Component
{
  render()
  {
    return (
      <div className='room-setup-room-chat-panel rounded-floating-element colour-dark-shade-bg'>
        <div className="room-setup-panel-title" >
          Room Chat
        </div>

        <ChatBox
          className="lobby-chat-box"
          messageListClassNamesPrefix="room-chat"
        />
      </div>
    );
  }
}

export default LobbyChat;
